var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jobs-nav-main",class:[_vm.border ? 'border' : '', _vm.link.length===1 ? 'hide-border' : '' ]},_vm._l((_vm.link),function(item,index){return _c('a',{key:index,class:['jobs-nav-menu', item.active ? 'active' : ''],attrs:{"href":item.url}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }